module.exports = __webpack_public_path__ + "deae8992a942ac31e2e23167f2be6e4b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-white.png
// module id = 1804
// module chunks = 0